import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
//import { observer, inject } from 'mobx-react';
import Loader from '../Loader/Loader';
import api from '../../api';
import './AddVersionModal.css';
//import WithRouter from '../Extensions/WithRouter';

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    const { translate } = props;
    this.modalAction = translate('modal.title.attention');
    this.modalBody = 'Do you want to delete this file?';
    this.state = {
      isModalLoader: false,
      isModalError: false,
      //isOpen: props.isOpen,
      //rowData: props.rowData,
      checkValues: props.checkValues || [],
    };
    this.closeModal = this.closeModal.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleMultipleDelete = this.handleMultipleDelete.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const {
      isOpen,
      checkValues,
      translate,
    } = this.props;

    if (prevProps.isOpen !== isOpen && isOpen) {
      this.modalBody = translate('modal.message.delete_this_files');
      this.setState({
        isModalError: false,
        isModalLoader: false,
      });
    }

    if (checkValues && prevProps.checkValues) {
      if (prevProps.checkValues.length !== checkValues.length) {
        this.setState({
          checkValues,
        });
      }
    }

  }

  handleDelete() {
    const { rowData, translate } = this.props;
    const { deletedCallback } = this.props;
    this.setState({
      isModalLoader: true,
    });
    api.deleteReport(rowData.uid || rowData.uploaded_file_id)
      .then(() => {
        this.setState({
          isModalLoader: false,
        }, () => {
          deletedCallback(rowData.uid || rowData.uploaded_file_id);
        });
      })
      .catch((err) => {
        console.log(err);
        this.modalAction = translate('modal.title.attention');
        this.modalBody = translate('modal.error.error_failed_delete_this_file');

        this.setState({
          isModalError: true,
          isModalLoader: false,
        });
      });
  }

  handleMultipleDelete() {
    const { checkValues } = this.state;
    const { handleMultipleDeleteCallback, translate } = this.props;
    const data = {
      uploaded_ids: checkValues,
    };

    this.setState({
      isModalLoader: true,
    }, () => {
      api
        .destroySelected(data)
        .then(() => {
          this.setState({
            isModalLoader: false,
          }, () => {
            handleMultipleDeleteCallback();
          });
        })
        .catch((err) => {
          console.log(err);
          this.modalAction = translate('modal.title.attention');
          const e = err.data.response;
          if (e.error === '422-201') {
            this.modalBody = translate('modal.error.error_422_201');
          }

          if (e.error === '422-206') {
            this.modalBody = translate('modal.error.error_422_206');
          }

          if (e.error === '422-366') {
            this.modalBody = e.error_description;
          }
          this.setState({
            isModalError: true,
            isModalLoader: false,
          });
        });
    });
  }

  closeModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  render() {
    const {
      isModalError, isModalLoader
    } = this.state;
    const { rowData, isOpen, translate } = this.props;

    const renderDeleteBtn = () => {
      if (rowData.uid || rowData.uploaded_file_id) {
        return (
          <a onClick={this.handleDelete} onKeyUp={this.handleDelete} className="right_button">
            {translate('modal.button.delete')}
          </a>
        );
      }
      return (
        <a onClick={this.handleMultipleDelete} onKeyUp={this.handleMultipleDelete} className="right_button">
          {translate('modal.button.delete')}
        </a>
      );
    };

    return (
      <Modal
        open={isOpen}
        onClose={this.closeModal}
      >
        <div className="modal_popup_wrap confirm_wrap">
          <div className="modal_popup_box confirm_box">
            {
              isModalLoader ? (
                <Loader />
              ) : (
                <div className="modal_popup confirm">
                  <h2 className="title">{this.modalAction}</h2>
                  <p className="text">{this.modalBody}</p>
                  {
                    rowData.uid || rowData.uploaded_file_id ? (
                      <p className="small_text" style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
                        &quot;
                        {rowData.name}
                        &quot;
                      </p>
                    ) : null
                  }
                  {
                    isModalError ? (
                      <div className="button_wrap">
                        <a onClick={this.closeModal} onKeyUp={this.closeModal} className="center_button">
                          {translate('modal.button.close')}
                        </a>
                      </div>
                    ) : (
                      <div className="button_wrap">
                        <a onClick={this.closeModal} onKeyUp={this.closeModal} className="left_button">
                          {translate('modal.button.cancel')}
                        </a>
                        {renderDeleteBtn()}
                      </div>
                    )
                  }
                </div>
              )
            }
          </div>
        </div>
      </Modal>
    );
  }
}

export default DeleteModal;
